type QuestTitleNavigationQuest = {
    id?: string | null
    parent_id?: string | null
    parent?: {
        id?: string | null
        quest_id?: string | null
    } | null
    sorted_answer_ids?: Array<string | number> | null
    sorted_answers?: unknown[] | null
}

export function childQuestIsKnownEmpty(quest: QuestTitleNavigationQuest): boolean {
    const hasDeclaredAnswerIds = Array.isArray(quest.sorted_answer_ids)
    const hasHydratedAnswers = Array.isArray(quest.sorted_answers)

    // Cache updates do not always write both projections in the same render. Treat the
    // branch as non-empty when either source already contains the first reply; otherwise
    // an optimistic sorted_answers append can keep opening the parent until IDs catch up.
    if (hasDeclaredAnswerIds && quest.sorted_answer_ids.length > 0) return false
    if (hasHydratedAnswers && quest.sorted_answers.length > 0) return false

    return hasDeclaredAnswerIds || hasHydratedAnswers
}

export function resolveQuestTitleNavigationTarget(
    quest: QuestTitleNavigationQuest,
): { questId: string; answerId: string } | null {
    const childQuestId = quest.id == null ? null : String(quest.id)
    const titleAnswerId = quest.parent?.id || quest.parent_id
    if (!childQuestId || !titleAnswerId) return null

    const parentQuestId = quest.parent?.quest_id
    const shouldOpenParent = !!parentQuestId && childQuestIsKnownEmpty(quest)

    return shouldOpenParent
        ? { questId: String(parentQuestId), answerId: String(titleAnswerId) }
        : { questId: childQuestId, answerId: String(titleAnswerId) }
}
